var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"orange-gradient",attrs:{"flat":"","large":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-login-variant")]),_vm._v("\n  Login\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }